"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberToSeq = void 0;
/**
 * 3 => [0, 1, 2, 3]のように連番に変換する
 * @param num
 * @returns
 */
const numberToSeq = (num) => Array.from(Array(num + 1).keys());
exports.numberToSeq = numberToSeq;
//# sourceMappingURL=arrayUtil.js.map